/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Referral_Apply_CodeInputs */

const en_mobile_referral_apply_code = /** @type {(inputs: Mobile_Referral_Apply_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply code`)
};

const es_mobile_referral_apply_code = /** @type {(inputs: Mobile_Referral_Apply_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar código`)
};

/**
* | output |
* | --- |
* | "Apply code" |
*
* @param {Mobile_Referral_Apply_CodeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_referral_apply_code = /** @type {((inputs?: Mobile_Referral_Apply_CodeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Referral_Apply_CodeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_referral_apply_code(inputs)
	return en_mobile_referral_apply_code(inputs)
});